<template>
    <transition name="slide">
        <router-view>

        </router-view>
    </transition>
</template>

<script>
    export default {
        name: "BaseNews",
    }
</script>

<style scoped>

</style>